import React from 'react';

const Clients = () => {
    const clients = [
        { id: 1, name: "Dr. Vishnu Mantri", role: "Commercial Project - Hospital" },
        { id: 2, name: "Mrs. Sangeeta Barve", role: "Residential Project" },
        { id: 3, name: "Mr. Tarun Kumar Jha", role: "Residential Project" },
        { id: 4, name: "Mr. Vikas Mishra", role: "Residential Project" },
        { id: 5, name: "Mr. Pawan Sharma", role: "Residential Project" },
        { id: 6, name: "100+ Happy Families", role: "And Counting..." },
    ];

    return (
        <section className="py-16 bg-white overflow-hidden">
            <div className="container mx-auto px-4 mb-10 text-center">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Trusted By</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                {clients.map((client) => (
                    <div
                        key={client.id}
                        className={`flex flex-col items-center justify-center px-8 py-8 rounded-xl border shadow-sm transition-all hover:shadow-md ${client.name.includes("100+")
                                ? "bg-primary text-white border-primary transform md:col-span-3 lg:col-span-3 mt-4"
                                : "bg-gray-50 border-gray-100 text-gray-800 hover:border-primary/30"
                            }`}
                    >
                        <span className={`font-bold text-lg text-center ${client.name.includes("100+") ? "text-white text-2xl" : "text-gray-800"}`}>
                            {client.name}
                        </span>
                        <span className={`text-sm mt-2 font-medium ${client.name.includes("100+") ? "text-white/90 uppercase tracking-widest" : "text-primary"}`}>
                            {client.role}
                        </span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Clients;
